<template>
	<div class="d-tab" :class="{ active: value == $.vnode.key, bubbles: bubbles }">
		<i class="fa" v-if="prependIcon != ''" :class="prependIcon" style="padding-right: 10px"></i>
		<slot></slot>
		<i style="padding-left: 10px" class="fa" v-if="appendIcon != ''" :class="appendIcon"></i>
		<div class="d-bar"></div>
	</div>
</template>
<script>
export default {
	name: "imdex-tab",
	props: {
		prependIcon: {
			type: String,
			default: ""
		},
		appendIcon: {
			type: String,
			default: ""
		},
		bubbles: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		value() {
			return this.$parent.$props.value;
		}
	},
	methods: {
		clickme() {
			this.$emit("inp", this.$.vnode.key);
		}
	}
};
</script>
<style scoped lang="scss">
.bubbles .d-tab {
	&.active {
		background: $imdex-secondary;
		color: #fff;
	}
	border: solid 2px $imdex-secondary;
	border-left: none;
	padding: 5px 20px;
	color: $imdex-secondary;
	font-size: 10px;
	&:hover {
		background: $imdex-secondary;
		color: #fff;
	}
	&:nth-child(1) {
		border-left: solid 2px $imdex-secondary;
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;
	}
	&:last-child {
		border-right: solid 2px $imdex-secondary;
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
	}
}
.d-tab {
	padding: 16px 32px;
	color: $imdex-dark;
	position: relative;
	font-weight: 500;
	text-align: center;
	i {
		color: $imdex-dark;
	}
	cursor: pointer;
	&:hover {
		color: $imdex-highlight;
		i {
			color: $imdex-highlight;
		}
		.d-bar {
			opacity: 1;
		}
	}
	&.active {
		color: $imdex-highlight;
		i {
			color: $imdex-highlight;
		}
		.d-bar {
			opacity: 1;
		}
	}
	.d-bar {
		opacity: 0;
		position: absolute;
		bottom: 0;
		height: 3px;
		width: 100%;
		left: 0;
		background: $imdex-secondary;
	}
}
</style>
